import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { FoldersSettingsDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import ToggleCustomFields from 'modules/documents/components/Settings/CustomFields/Toggle'
import FoldersTable from 'modules/documents/components/Settings/FoldersTable'
import TableHeader from 'modules/documents/components/Settings/FoldersTable/Header'
import { Folder } from 'modules/documents/hooks/useGetFolders'
import { sortFoldersByName } from 'modules/documents/lib/Folders'
import { SPACES } from 'modules/documents/lib/constants'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

interface Props {
  space: (typeof SPACES)[keyof typeof SPACES]
  newFolderRoute: string
  folderVariables: { [key: string]: boolean | string | number }
  folder?: Folder
  canManage: boolean
}

const FoldersSettings = ({ space, folderVariables, folder, newFolderRoute, canManage }: Props) => {
  const navigate = useNavigate()
  const { data, loading, error } = useQuery(FoldersSettingsDocument, {
    variables: folderVariables,
  })
  const openCreateModal = () => navigate(newFolderRoute)

  const sortedFolders = sortFoldersByName(data?.documents.folders || [])

  return (
    <>
      <AuthorizeUser authorizeFn={() => canManage}>
        <ResponsivePage.Body showHeader={false} loading={loading} error={error}>
          <Box>
            <Box gap="s32">
              <TableHeader folder={folder} openCreateModal={openCreateModal} space={space} />
              <FoldersTable
                folders={sortedFolders}
                space={space}
                currentFolder={folder}
                openCreateModal={openCreateModal}
              />
            </Box>
            {folder && !folder.showOnly && <ToggleCustomFields folder={folder} />}
          </Box>
        </ResponsivePage.Body>
      </AuthorizeUser>
    </>
  )
}

export default FoldersSettings
